import { useMemo } from 'react';
import _ from 'lodash';
import { useInstitutionCategories } from 'api/hooks';
import { Select, Loader } from '@mantine/core';

const errorClasses =
  ' data-[error=true]:border-red-500  data-[error=true]:border-red-500 data-[error=true]:focus:border-red-500 data-[error=true]:focus:ring-red-500';

export default function InstitutionCategorySelect({ ...rest }) {
  const { categories, isLoading } = useInstitutionCategories({});
  const options = useMemo(() => {
    return _.map(categories, (category) => ({
      value: `${category.id}`,
      label: category.name,
    }));
  }, [categories]);
  return (
    <Select
      classNames={{
        input: `border border-slate-300 shadow-sm focus:ring-1 focus:border-indigo-600 focus:ring-indigo-600  data-[error=true]:border-red-500 ${errorClasses}`,
      }}
      rightSection={isLoading && <Loader size={20} color="zinc.2" />}
      data={options}
      searchable
      {...rest}
    />
  );
}
